<template>
  <div ref="containerRef">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import useExpandAncestorToFit from '@app/shared/vue/composables/use-fit-into-parent'

const containerRef = ref<HTMLElement | null>(null)

useExpandAncestorToFit(containerRef, {
  ancestor: '.multiselect-dropdown',
  enabled: true,
  heightOffset: 16,
  widthOffset: 24,
})
</script>
